import { type UseQueryOptions, useQuery } from '@tanstack/react-query';

import { Services } from '@/infra/services';
import { type ItemId } from '@/infra/services/catalog/model';
import { type Response } from '@/infra/services/catalog/product/get-crosses-products';
import { TWO_MINUTES_IN_MILISECONDS } from '@/utils/constants/time';

type CrossesQueryOptions = Omit<
  UseQueryOptions<Response, Error, Response>,
  'queryKey' | 'queryFn'
>;

const useCrossesProducts = (itemId: ItemId, options?: CrossesQueryOptions) => {
  const result = useQuery<Response, Error, Response>({
    queryKey: ['get-crosses-products', itemId],
    queryFn: () => Services.Catalog.Product.getCrossesProducts({ itemId }),
    staleTime: TWO_MINUTES_IN_MILISECONDS,
    ...options,
  });

  return result;
};

export default useCrossesProducts;
